import { FC, HtmlHTMLAttributes, PropsWithChildren } from 'react';

export const FlexShrink: FC<PropsWithChildren & HtmlHTMLAttributes<HTMLDivElement>> = (props) => (
    <div className="flex-shrink whitespace-nowrap" {...props}>
        {props.children}
    </div>
);
